import environment from "environment";

export const oneTrustScript = () => {

    const scriptOtAutoBlock = document.createElement("script");
    scriptOtAutoBlock.setAttribute('type', 'text/javascript');
    scriptOtAutoBlock.setAttribute('src', `https://cdn-apac.onetrust.com/consent/${environment.oneTrustDataDomainScript}/OtAutoBlock.js`);
    document.head.appendChild(scriptOtAutoBlock);

    const scriptOtSDKStub = document.createElement("script");
    scriptOtSDKStub.setAttribute('type', 'text/javascript');
    scriptOtSDKStub.setAttribute('src', 'https://cdn-apac.onetrust.com/scripttemplates/otSDKStub.js');
    scriptOtSDKStub.setAttribute('charset', 'UTF-8');
    scriptOtSDKStub.setAttribute('data-domain-script', environment.oneTrustDataDomainScript);
    scriptOtSDKStub.setAttribute('data-document-language', 'true');
    document.head.appendChild(scriptOtSDKStub);

    const scriptFunction = document.createElement("script");
    scriptFunction.setAttribute('type', 'text/javascript');
    scriptFunction.innerText = "function OptanonWrapper() {}";
    document.head.appendChild(scriptFunction);
}